import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Components from './components'
import '@fortawesome/fontawesome-free/css/all.css'
import {getThemeFromLocalStorage} from "@/utils/pureFunctions";
import 'roboto-fontface/css/roboto/roboto-fontface.css'

Vue.use(Components)


Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                success: '#2ED47A',
                primary: '#1f74ff',
                warning: '#FFB946',
                error: '#F7685B',
                secondary: '#334D6E',
                accent: '#82B1FF',
                info: '#109CF1',
                blueviolet: "#272B48"
            },
            dark: {
                blueviolet: "#272B48",
            }
        },
        customProperties: true,
        dark: getThemeFromLocalStorage() === 'dark'
    },
    icons: {
        iconfont: 'fa',
    },
});
